var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"self",class:_vm.className,style:(_vm.style),on:{"mousedown":_vm.mousedown,"touchstart":_vm.mousedown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }